import { Component, ViewChild } from '@angular/core';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.css']
})
export class FeedbackComponent {
  display: boolean = false;
  feedbackText: string = '';

  submitFeedback() {
    // Send feedback to your backend (e.g., using an HTTP service)
    console.log('Feedback submitted:', this.feedbackText);
    this.display = false;
  }
}
